import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SocialMarketTransactionsState } from "./types";
import { fetchTradingPartners, fetchTransactions } from "./social-market-transactions-thunk";
import { ErrorType } from "@/shared/types";

const currentDate = new Date()

const initialState: SocialMarketTransactionsState = {
    transactions: [],
    cursor: 0,
    count: 20,
    isTransactionsLoading: false,
    isTransactionsFirstLoad: true,
    transactionsError: null,
    end: false,
    deals: {},
    startDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), 1),
    endDate: new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 1),
    selectedPartner: null,
    destType: '1',
    partners: [],
    isPartnersLoading: false,
    isPartnersFirstLoad: true,
    partnersError: null
}

const socialMarketTransactionsSlice = createSlice({
    name: 'socialMarketTransactions',
    initialState,
    reducers: {
        setStartDate: (state, action: PayloadAction<Date>) => {
            state.startDate = action.payload
            state.cursor = 0
            state.deals = {}
            state.isTransactionsFirstLoad = true
            state.transactions = []
        },
        setEndDate: (state, action: PayloadAction<Date>) => {
            state.endDate = action.payload
            state.cursor = 0
            state.deals = {}
            state.isTransactionsFirstLoad = true
            state.transactions = []
        },
        setSelectedPartner: (state, action: PayloadAction<string | null>) => {
            state.selectedPartner = action.payload
            state.cursor = 0
            state.deals = {}
            state.isTransactionsFirstLoad = true
            state.transactions = []
        },
        setDestType: (state, action: PayloadAction<string | null>) => {
            state.destType = action.payload
            state.cursor = 0
            state.deals = {}
            state.isTransactionsFirstLoad = true
            state.transactions = []
        },
    },
    extraReducers(builder) {
        builder
        .addCase(fetchTransactions.pending, (state) => {
            state.isTransactionsLoading = true
        })
        .addCase(fetchTransactions.fulfilled, (state, action) => {
            state.isTransactionsFirstLoad = false
            state.transactions = action.payload.items
            if (state.cursor === action.payload.cursor) {
                state.end = true
            }
            state.deals = {...state.deals, ...action.payload.deals}
            state.cursor = action.payload.cursor
            state.isTransactionsLoading = false
            state.transactionsError = null
        })
        .addCase(fetchTransactions.rejected, (state, action) => {
            state.isTransactionsLoading = false
            state.transactionsError = action.payload as ErrorType ?? null
        })
        .addCase(fetchTradingPartners.pending, (state) => {
            state.isPartnersLoading = false
        })
        .addCase(fetchTradingPartners.fulfilled, (state, action) => {
            state.isPartnersFirstLoad = false
            state.partnersError = null
            state.partners = action.payload
            state.isPartnersLoading = false
        })
        .addCase(fetchTradingPartners.rejected, (state, action) => {
            state.partnersError = action.payload as ErrorType ?? null
            state.isPartnersLoading = false
        })
    },
})

export default socialMarketTransactionsSlice.reducer
export const { setDestType, setEndDate, setSelectedPartner, setStartDate } = socialMarketTransactionsSlice.actions
